import Vue from 'vue';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueRouter from 'vue-router';
import App from './App.vue';
import router from './router';
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import store from './store'; // Importa tu archivo store.js
import moment from 'moment';

import VueQrcodeReader from 'vue-qrcode-reader'

Vue.use(VueQrcodeReader)

Vue.prototype.moment = moment;

import VueMask from 'v-mask'
Vue.use(VueMask);

// Crear el Event Bus y añadirlo al prototipo de Vue
Vue.prototype.$eventBus = new Vue();


import './mixins/valitators';
Vue.use(Vuesax, {})
Vue.use(VueRouter);

Vue.config.productionTip = false;




let socket;
let isConnected = false;
let isReconnecting = false;  // Flag para evitar múltiples reconexiones
let reconnectTimeout;  // Variable para manejar el reconectado

// Función para conectar WebSocket
function connectWebSocket() {
  // Verificar que no haya una conexión cerrada o en proceso de cierre
  if (socket && socket.readyState !== WebSocket.CLOSED && socket.readyState !== WebSocket.CLOSING) {
    return;  // No intentamos reconectar si ya está abierto o en conexión
  }

  socket = new WebSocket("wss://agtl.ink");

  socket.onopen = () => {
    isConnected = true;
    isReconnecting = false; // Reseteamos el flag de reconexión
    clearTimeout(reconnectTimeout);  // Limpiamos el timeout de reconexión
  };

  socket.onclose = () => {
    isConnected = false;
    if (!isReconnecting) {
      isReconnecting = true;  // Activamos el flag de reconexión
      reconnectTimeout = setTimeout(connectWebSocket, 5000);  // Intentar reconectar después de 5 segundos
    }
  };

  // socket.onmessage = (event) => {
  //   const message = JSON.parse(event.data);
  //   console.log("📩 Mensaje recibido:", message);
  //   if (message.action === "refresh") {
  //     location.reload(); // Recargar la página si se recibe el mensaje de "refresh"
  //   }
  // };

  socket.onerror = (error) => {
    socket.close();  // Aseguramos que se cierre si ocurre un error
  };

  // Hacer que el WebSocket esté disponible globalmente en Vue.js
  Vue.prototype.$socket = socket;
  Vue.prototype.$isConnected = isConnected;
}

// Inicializar WebSocket al cargar la página
connectWebSocket();


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB7dZRt25HvfRTlK9rehEArICUKvRGGezg',
    v: '3.26',
    libraries: 'places,drawing', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})



// Esperar a que Firebase determine el estado de autenticación antes de montar la app
import { auth } from './fb';
import { onAuthStateChanged } from 'firebase/auth';

let app = null;
onAuthStateChanged(auth, () => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
});